"use strict";
// @ts-ignore
try {
    self['workbox:streams:5.1.3'] && _();
}
catch (e) { }
